import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const ModalTabHeader = ({ show, tabs, activeTab }) => {
  if (!show) return null;

  const activeIndex = tabs.findIndex(t => t.index === activeTab);

  return (
    <div className="modal-tabs-header">
      {tabs.map((t, i) => (
        <div
          key={t.index}
          className={classnames('modal-tab', {
            'modal-tab-visited': i < activeIndex,
            'modal-tab-active': t.index === activeTab,
          })}
        >
          <div className="modal-tab-bar" />
          <span>{t.label}</span>
        </div>
      ))}
    </div>
  );
};

ModalTabHeader.propTypes = {
  show: PropTypes.bool.isRequired,
  tabs: PropTypes.array.isRequired,
  activeTab: PropTypes.string.isRequired,
};

export default ModalTabHeader;
